if (!customElements.get('header-wrapper')) {
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
      this.isFixed = false;
      this.announcementBar = document.querySelector('.js-announcement-bar');
      this.wrapper = document.querySelector('.js-wrapper');
      this.dropdowns = this.querySelectorAll('details:not([open]):not(.js-ignore)');
      this.breakpointTablet = 989;
    }

    setHeightProperty() {
      document.body.style.setProperty(`--header-inner-height`, `${this.querySelector('header')?.clientHeight}px`);
      document.body.style.setProperty(`--header-wrapper-height`, `${this.clientHeight}px`);
    }

    toggleFixedClasses() {
      if(this.announcementBar) {
        this.announcementBar.classList.toggle('is-fixed', this.isFixed);
      }

      this.classList.toggle('is-fixed', this.isFixed);

      if(this.isFixed) {
        this.setHeightProperty();
      }
    }

    handleScrollEvent() {
      this.isFixed = window.scrollY > 0;
      this.toggleFixedClasses();
    }

    initOnScrollEvent() {
      window.addEventListener('scroll', () => this.handleScrollEvent());
      this.handleScrollEvent();
    }

    removeOnclick() {
      const button = this.querySelector('.js-remove-onclick');

      button.removeAttribute('onclick');
      button.onclick = null;
    }

    isIos() {
      if (typeof window === `undefined` || typeof navigator === `undefined`) return false;

        return /iPhone|iPad|iPod/i.test(navigator.userAgent || navigator.vendor || (window.opera && opera.toString() === `[object Opera]`));
    }

    isSafari(){
      if (typeof window === `undefined` || typeof navigator === `undefined`) return false;
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    isFirefox() {
      if (typeof window === `undefined` || typeof navigator === `undefined`) return false;
      return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }


    alignmentOfMenuList(dropdown) {
      if(!dropdown) return;
      const submenuFirstChildrenList = dropdown.querySelectorAll('.menu-block__menu_list details:first-child');
      let height = 0;

      // loop 1, find the tallest menu.
      // do not assign height in this loop, as it is subject to change in each run, and we want to avoid multiple re-sizing.
      submenuFirstChildrenList.forEach((el) => {
        // re-assign height to the tallest element if this element is the tallest.
        if(el.getBoundingClientRect().height > height) {
          height = el.getBoundingClientRect().height;
        }
      });

      // loop 2, apply the tallest height.
      submenuFirstChildrenList.forEach((el) => {
        el.style.height = (height/10) + 'rem';
      });
    }

    connectedCallback() {
      this.setHeightProperty();

      const anchors = this.querySelectorAll('a');
      const isIos = this.isIos();
      const isSafari = this.isSafari();
      const isFirefox = this.isFirefox();
      anchors.forEach(anchor => {
        const hasButton = anchor.querySelector('button');
        if(anchor.innerHTML.trim() == '' || hasButton) anchor.parentElement.removeChild(anchor);

        anchor.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });

      if(window.innerWidth <= this.breakpointTablet) this.removeOnclick();

      // const submenus = this.querySelectorAll('.menu-drawer__submenu');

      // submenus.forEach((submenu) => { submenu.style.marginTop = `-${submenu.offsetHeight / 2}px`; });

      this.dropdowns.forEach((dropdown) => {
        if(isIos) dropdown.style.maxHeight = 'auto';

        dropdown.addEventListener('mouseenter', (event) => {
          if(window.innerWidth <= this.breakpointTablet) return;

          // Chrome will calculate the size of a hidden element, other browsers will not.
          // Skip size recalcuation on Safari and Firefox.
          if(!isSafari && !isFirefox) this.alignmentOfMenuList(dropdown);

          dropdown.setAttribute('open', '');
          const ul = dropdown.querySelector('summary + ul');
          ul.style.maxHeight = (ul.scrollHeight / 10) + 'rem';

        });

        dropdown.addEventListener('mouseleave', (event) => {
          if(window.innerWidth <= this.breakpointTablet) return;

          let ul = dropdown.querySelector('summary + ul');
          ul.style.maxHeight = '0rem';

          dropdown.removeAttribute('open');
        });

        dropdown.addEventListener('click', (event) => {
          let isAnchor = event.target.tagName.toLowerCase() == 'a';
          if(isAnchor && window.innerWidth >= this.breakpointTablet) {
            window.location.href = event.target.getAttribute('href');
            return false;
          }

          event.preventDefault();
          event.stopPropagation();

          if(window.innerWidth > this.breakpointTablet) return;
          const parentDropdown = dropdown.closest('details:not(.js-ignore)');
          const grandparentDropdown = parentDropdown ? parentDropdown.closest('details:not(.js-ignore)') : null;

          if(!dropdown.hasAttribute('open')) {
            dropdown.setAttribute('open', '');
            const div = dropdown.querySelector('summary + div');
            const maxHeight = dropdown.getBoundingClientRect().height + div.getBoundingClientRect().height;
            dropdown.style.maxHeight = maxHeight > 0 ? maxHeight + 'px' : 'auto';
            let parentDropdownHeight = parentDropdown.clientHeight + maxHeight
            if(parentDropdown) {
              parentDropdown.setAttribute('data-original-height', parentDropdown.clientHeight);
              parentDropdown.style.maxHeight = maxHeight > 0 ? parentDropdownHeight + 'px' : 'auto';
            }
            if(grandparentDropdown && parentDropdown) {
              grandparentDropdown.setAttribute('data-original-height', grandparentDropdown.clientHeight + parentDropdownHeight);
              grandparentDropdown.style.maxHeight = maxHeight > 0 ? grandparentDropdown.clientHeight + pparentDropdownHeight + maxHeight + 'px' : 'auto';
            }
          } else {
            const summary = dropdown.querySelector('summary');
            const summaryHeight = summary.getBoundingClientRect().height;
            dropdown.style.maxHeight = summaryHeight > 0 ? summaryHeight + 'px' : 'auto';
            if(parentDropdown.hasAttribute('data-original-height')) parentDropdown.style.maxHeight = parentDropdown.getAttribute('data-original-height') + 'px';
            if(grandparentDropdown.hasAttribute('data-original-height')) grandparentDropdown.style.maxHeight = grandparentDropdown.getAttribute('data-original-height') + 'px';
            this.timeout = window.setTimeout(() => {
              dropdown.removeAttribute('open');
              clearTimeout(this.timeout);
            }, 500);
          }
        });

        if(window.innerWidth > this.breakpointTablet) return;
        const dropSummary = dropdown.querySelector('summary');
        // dropdown.style.maxHeight = dropSummary.getBoundingClientRect().height + 'px';
      });

      const childLinks = this.querySelectorAll('.js-header-childlink');

      childLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          if(window.innerWidth <= this.breakpointTablet) return;
          if(!event.target.classList.contains('js-header-childlink')) return;

          event.preventDefault();
        });
      });

      const summaryAnchors = this.querySelectorAll('summary > a');

      summaryAnchors.forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
          if(window.innerWidth > this.breakpointTablet) return;

          anchor.parentElement.click();
          return false;
        });
      });

      if(!this.classList.contains('js-sticky')) return;
      this.initOnScrollEvent();
    }
  }

  customElements.define('header-wrapper', HeaderWrapper);
}
